export enum OrderPaymentStatus {
  Paid = 'PAID',
  Unpaid = 'UNPAID',
}
